module.exports = __webpack_public_path__ + "static/media/block_icon_image.2df39cf4.svg";